import React, { useCallback } from 'react';
import { HiOutlineChevronLeft } from 'react-icons/hi';

export interface Props {
  showArrow?: boolean;
  onClickHandler?: () => void;
  size?: number;
}

const LeftArrow = ({ onClickHandler, showArrow, size = 25 }: Props) => {
  const onClick = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      onClickHandler();
    },
    [onClickHandler],
  );
  return showArrow ? (
    <HiOutlineChevronLeft
      className="!absolute cursor-pointer top-0 z-50 flex items-center h-full p-0 text-white"
      onClick={onClick}
      size={size}
    />
  ) : null;
};

export default LeftArrow;
